<template>
    <section class="up_pa">
        <el-dialog
            title="修改密码"
            :visible.sync="visible"
            :append-to-body="true">
            <el-form
                :model="dataForm"
                :rules="dataRule"
                ref="dataForm"
                @keyup.enter.native="dataFormSubmit()"
                label-width="80px">
                <el-form-item label="账号">
                    <span>{{dataForm.userName}}</span>
                </el-form-item>
                <el-form-item
                    label="原密码"
                    prop="password">
                    <el-input
                        type="password"
                        v-model="dataForm.password"></el-input>
                </el-form-item>
                <el-form-item
                    label="新密码"
                    prop="newPassword">
                    <el-input
                        type="password"
                        v-model="dataForm.newPassword"></el-input>
                </el-form-item>
                <el-form-item
                    label="确认密码"
                    prop="confirmPassword">
                    <el-input
                        type="password"
                        v-model="dataForm.confirmPassword"></el-input>
                </el-form-item>
                <div class="dialog_foot">
                    <p class="dialog_foot_button">
                        <el-button
                            size="small"
                            @click="visible=false">取消</el-button>
                        <el-button
                            size="small"
                            type="info"
                            @click="submitForm">确定</el-button>
                    </p>
                </div>
            </el-form>
        </el-dialog>
    </section>
</template>

<script>
    import {
        userPassword
    } from 'src/api/common.api.js';

    export default {
        data () {
            var validateConfirmPassword = (rule, value, callback) => {
                if (this.dataForm.newPassword !== value) {
                    callback(new Error('确认密码与新密码不一致'));
                } else {
                    callback();
                }
            };

            return {
                visible: false,
                dataForm: {
                    userName: '',
                    password: '',
                    newPassword: '',
                    confirmPassword: ''
                },
                dataRule: {
                    password: [
                        {required: true, message: '原密码不能为空', trigger: 'blur'}
                    ],
                    newPassword: [
                        {required: true, message: '新密码不能为空', trigger: 'blur'}
                    ],
                    confirmPassword: [
                        {required: true, message: '确认密码不能为空', trigger: 'blur'},
                        {validator: validateConfirmPassword, trigger: 'blur'}
                    ]
                }
            };
        },
        created () {

        },
        methods: {
            /**
             * [init 初始化弹窗]
             * @param  {[type]} userName [description]
             * @return {[type]}          [description]
             */
            init: function (userName) {
                let that = this;

                that.visible = true;
                that.dataForm.userName = userName;
            },

            /**
             * [submitForm 提交表单]
             * @return {[type]} [description]
             */
            submitForm: function () {
                let that = this,
                    common = that.common,
                    serve = common.serve.http,
                    dataForm = that.dataForm,
                    obj = {
                        password: dataForm.password,
                        newPassword: dataForm.newPassword

                    };

                that.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        serve.httpRequest(obj, userPassword, _cb); 
                    }
                });

                function _cb (res) {
                    if (res.code === 0) {
                        that.$message.success(res.msg);
                        localStorage.removeItem('token');
                        that.$router.replace({name: 'login'});
                    } else {
                        that.$message.error(res.msg);
                    }
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/common/home/home-nav-bar/update-password/update-password.vue